<template>
	<CDialog
		:title="title"
		:visible="isVisible"
		custom-class="cognito dialog--tiny"
		@close="$emit('close')"
		@closed="$emit('closed')"
	>
		<template #headerImage>
			<Inline :svg="icon" />
		</template>

		<div class="c-label">
			<label>View Name</label>
		</div>
		<div>
			<CValidatedInput
				id="view"
				ref="nameInput"
				v-model.trim="viewName"
				rules="required"
				mode="Aggressive"
				autocomplete="off"
				type="text"
				name="View Name"
				maxlength="140"
				:immediate="true"
			/>
		</div>

		<template #footer>
			<CStatusButton class="button button button--secondary mt-4" status="default" @click.native="isVisible = false">
				Cancel
			</CStatusButton>
			<CStatusButton class="button button--primary mt-4" :status="buttonStatus" :auto-reset="false" @click.native="onCopy">
				Copy
			</CStatusButton>
		</template>
	</CDialog>
</template>

<script lang="ts">
	import type { PropType } from 'vue';
	import { computed, defineComponent, ref, watch } from 'vue';
	import CDialog from 'src/components/dialogs/Dialog.vue';
	import CValidatedInput from 'src/components/form-controls/ValidatedInput.vue';
	import type { ButtonStatus } from 'src/components/interaction/StatusButton.vue';
	import CStatusButton from 'src/components/interaction/StatusButton.vue';
	import type { UserEntryViewMeta } from '@cognitoforms/types/server-types/core/services/user-entry-view-meta';
	import { ViewType } from '@cognitoforms/types/server-types/forms/model/view-type';

	export default defineComponent({
		name: 'CEntryViewSettingsDialog',
		components: {
			CValidatedInput,
			CDialog,
			CStatusButton
		},
		props: {
			view: {
				type: Object as PropType<UserEntryViewMeta>,
				required: true
			},
			show: {
				type: Boolean,
				default: false
			}
		},
		emits: ['copy', 'close', 'closed'],
		setup(props, { emit }) {
			const isVisible = ref(false);
			watch(() => props.show, (isOpen) => {
				isVisible.value = isOpen;
			}, { immediate: true });

			const viewName = ref(`Copy of ${props.view.Name}`);

			const title = computed(() => `Copy ${props.view.Name} View`);
			const icon = computed(() => {
				switch (props.view.Type) {
				case ViewType.Form:
					return 'form-view';
				case ViewType.Table:
				default:
					return 'grid';
				}
			});

			const buttonStatus = computed<ButtonStatus>(() => viewName.value ? 'default' : 'disabled');

			const onCopy = () => {
				isVisible.value = false;
				emit('copy', viewName.value);
			};

			return {
				isVisible,
				viewName,
				title,
				icon,
				buttonStatus,
				onCopy
			};
		}
	});
</script>
